import { dataMute } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMute = /*#__PURE__*/createIcon(dataMute)
export default IconMute
